import { ServiceConfig } from "../types";

export const DEFAULT_SERVICES: Record<string, ServiceConfig> = {
  auth: {
    baseURL:
      process.env.NEXT_PUBLIC_AUTH_API_URL ||
      "http://192.168.1.8:3067/api/auth",
    timeout: 10000,
  },
  web: {
    baseURL:
      process.env.NEXT_PUBLIC_WEB_API_URL || "http://192.168.1.8:3067/api",
    timeout: 10000,
  },
};

export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};
